import angular from 'angular';
import uiRouter from 'angular-ui-router';
import listComponent from './list.component';
import ListCompany from './listCompany/listCompany';
import ListDealers from './listDealers/listDealers';
import ListLocations from './listLocations/listLocations';
import Pagination from 'angular-ui-bootstrap/src/pagination';
import Dropdown from 'angular-ui-bootstrap/src/dropdown';

let listModule = angular.module('list', [
  uiRouter,
  ListCompany,
  ListDealers,
  ListLocations,
  Pagination,
  Dropdown
])

.config(($stateProvider) => {
  "ngInject";

  $stateProvider
    .state('admin.entity.listCompanies', {
      url: '/:entityType/list',
      component: 'list'
    });

    $stateProvider
      .state('admin.entity.listChildren', {
        url: '/:entityType/:entityId/list',
        component: 'list'
      });
})

.component('list', listComponent)

.name;

export default listModule;



// WEBPACK FOOTER //
// ./client/app/components/admin/entity/list/list.js